<template>
  <div class="download_btn excel-btns" v-if="HideAndShow">
    <div v-if="isExcelLoading || isPdfLoading" class="export-loading">
      <i :class="['pi', isExcelLoading ? 'pi-file-excel' : 'pi-file-pdf']"></i>
      <span>{{ isExcelLoading ? 'Exporting Excel...' : 'Exporting PDF...' }}</span>
    </div>
    <i v-else class="pi pi-download" title="Download" @click="toggle" aria-haspopup="true"
      aria-controls="overlay_menu"></i>
    <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" />
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  PropType,
  reactive,
  computed,
  watch,
  onMounted,
} from "vue";

import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { boolean } from "yup";
// import { string } from "yup";

export default defineComponent({
  components: {},

  props: {
    ExportList: {
      type: Array,
      default: [],
    },
    PageName: {
      type: String,
      default: "",
    },
    ExportOption: {
      type: String,
      default: "",
    },
    HideAndShow: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const menu = ref();
    const isExcelLoading = ref(false);
    const isPdfLoading = ref(false);

    const items = ref([
      {
        label: "Download",
        items: [
          {
            label: "Excel",
            icon: "pi pi-file-excel",
            command: async () => {
              ExportExcel();
            },
          },
          {
            label: "Pdf",
            icon: "pi pi-file-pdf",
            command: async () => {
              ExportPDF();
            },
          },
        ],
      },
    ]);

    const toggle = (event) => {
      menu.value.toggle(event);
    };

    function ExportExcel() {
      debugger;
      isExcelLoading.value = true;
      emit("ExportExcel");
    }

    function ExportPDF() {
      debugger;
      isPdfLoading.value = true;
      emit("ExportPDF");
    }

    watch(
      () => props.ExportList,
      (newVal: any) => {
        debugger;
        if (props.ExportOption == "Excel") {
          Excel(newVal);
        } else if (props.ExportOption == "PDF") {
          PDF(newVal);
        } else {
          alert("Something went wrong");
          // Reset loading states in case of error
          isExcelLoading.value = false;
          isPdfLoading.value = false;
        }
      }
    );

    //Export as Excel
    async function Excel(ExcelData) {
      debugger;
      try {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Sheet1");

        // Add headers
        const headers = Object.keys(ExcelData[0]);
        sheet.addRow(headers);

        // Add data
        ExcelData.forEach((item) => {
          const row: any = [];
          headers.forEach((header) => {
            row.push(item[header]);
          });
          sheet.addRow(row);
        });

        // Create a blob from the Excel workbook
        const blob = await workbook.xlsx.writeBuffer();

        // Trigger a file download
        const blobUrl = URL.createObjectURL(
          new Blob([blob], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "" + props.PageName + ".xlsx";
        link.click();
        URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error("Excel export error:", error);
      } finally {
        // Reset loading state
        isExcelLoading.value = false;
      }
    }

    //Export as PDF
    async function PDF(PdfData) {
      try {
        const headers = Object.keys(PdfData[0]);

        // Analyze data to determine optimal layout
        const getTextWidth = (text, fontSize) => text.length * fontSize * 0.6; // Approximate width

        // Format headers and analyze content
        const formattedHeaders = headers.map(header =>
          header
            .replace(/([A-Z])/g, ' $1')
            .replace(/_/g, ' ')
            .replace(/^\w/, c => c.toUpperCase())
            .trim()
        );

        // Process and analyze data
        const data = PdfData.map(item =>
          headers.map(header => {
            const value = item[header];
            if (value === null || value === undefined) return '';
            if (typeof value === 'number') return value.toLocaleString();
            if (value instanceof Date) return value.toLocaleDateString();
            return String(value);
          })
        );

        // Calculate maximum content widths
        const contentWidths = headers.map((_, colIndex) => {
          const headerWidth = getTextWidth(formattedHeaders[colIndex], 12);
          const maxDataWidth = Math.max(...data.map(row =>
            getTextWidth(row[colIndex], 10)
          ));
          return Math.max(headerWidth, maxDataWidth);
        });

        // Always use landscape
        const pdf: any = new jsPDF({
          orientation: 'landscape',
          unit: 'pt'
        });

        // Get page dimensions
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Set margins
        const margins = {
          top: 40,
          right: 20,
          bottom: 40,
          left: 20
        };
        const availableWidth = pageWidth - margins.left - margins.right;

        // Calculate column widths based on content type and length
        const columnWidths: { [key: number]: number } = {};

        headers.forEach((_, index) => {
          const headerText = formattedHeaders[index];
          const sampleValue = data[0]?.[index];

          // Base width calculation
          let width: number;

          // Special handling for data types
          if (typeof sampleValue === 'number') {
            width = 32; // Numbers get minimal width
          } else if (sampleValue instanceof Date) {
            width = 45; // Dates get slightly more
          } else {
            // Text content - size based on typical content length
            const maxContentLength = Math.max(
              headerText.length,
              ...data.map(row => String(row[index] || '').length)
            );

            if (maxContentLength <= 5) {
              width = 32; // Very short text
            } else if (maxContentLength <= 10) {
              width = 40; // Short text
            } else if (maxContentLength <= 15) {
              width = 48; // Medium text
            } else if (maxContentLength <= 20) {
              width = 56; // Long text
            } else {
              width = 64; // Very long text
            }
          }

          columnWidths[index] = width;
        });

        // Calculate total width needed
        const totalWidth = Object.values(columnWidths).reduce((sum: number, width: number) => sum + width, 0);

        // If total width exceeds available width, scale down proportionally
        if (totalWidth > availableWidth) {
          const scale = availableWidth / totalWidth;
          headers.forEach((_, index) => {
            columnWidths[index] = Math.max(28, Math.floor(columnWidths[index] * scale));
          });
        }

        // Add title
        pdf.setFontSize(11);
        pdf.setTextColor(40);
        pdf.text(props.PageName, margins.left, margins.top);

        // Configure table
        pdf.autoTable({
          head: [formattedHeaders],
          body: data,
          startY: margins.top + 20,
          margin: margins,
          styles: {
            fontSize: 6.5,
            cellPadding: { top: 2, right: 1, bottom: 2, left: 1 },
            overflow: 'linebreak',
            cellWidth: 'wrap',
            textColor: [50, 50, 50],
            minCellHeight: 12,
            halign: 'left',
            valign: 'middle'
          },
          columnStyles: Object.fromEntries(
            headers.map((_, index) => [
              index,
              {
                cellWidth: columnWidths[index],
                halign: typeof data[0]?.[index] === 'number' ? 'right' : 'left',
                valign: 'middle',
                overflow: 'linebreak'
              }
            ])
          ),
          headStyles: {
            fillColor: [99, 102, 241],
            textColor: 255,
            fontSize: 7,
            fontStyle: 'bold',
            halign: 'left',
            cellPadding: { top: 2, right: 1, bottom: 2, left: 1 }
          },
          bodyStyles: {
            fontSize: 6.5,
            textColor: 50,
            lineColor: [220, 220, 220],
            lineWidth: 0.5
          },
          alternateRowStyles: {
            fillColor: [245, 245, 245]
          },
          didDrawPage: function (data) {
            pdf.setFontSize(7);
            pdf.setTextColor(150);
            pdf.text(
              `Page ${data.pageNumber}`,
              pageWidth / 2,
              pageHeight - 20,
              { align: 'center' }
            );
          }
        });

        // Save the PDF
        pdf.save(`${props.PageName}.pdf`);
      } catch (error) {
        console.error("PDF export error:", error);
      } finally {
        // Reset loading state
        isPdfLoading.value = false;
      }
    }

    return {
      ExportExcel,
      ExportPDF,
      items,
      toggle,
      menu,
      isExcelLoading,
      isPdfLoading
    };
  },
});
</script>

<style lang="scss">
.excel-btns .pi {
  margin: 0 10px;
  color: #6366f1;
  background-color: #e1e1e1;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

.export-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 10px;
  background-color: #e0f7e0;
  /* Light green background */
  padding: 6px 10px;
  /* Reduced padding for less height */
  border-radius: 5px;

  i {
    color: #4caf50;
    /* Green icon color to match the theme */
    font-size: 10px;
    animation: pulse 1.5s infinite;
  }

  span {
    font-size: 13px;
    /* Slightly smaller font */
    color: #333;
    white-space: nowrap;
  }
}

@keyframes pulse {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }

  100% {
    opacity: 1;
  }
}
</style>
